import { createPortal } from "react-dom";

/* GFI Nexus — Document preview modal
   ─────────────────────────────────────────────────────────────────
   Renders an HTML string inside an iframe (srcDoc) so the user can
   eyeball the doc before printing. Has a Print button that opens
   the doc in a fresh window and triggers the browser's print
   dialog — same path the existing print buttons use, just behind a
   "see it first" step.

   Props:
     - title    string    modal title bar
     - html     string    full HTML doc (whatever buildXyzHTML() returns)
     - onClose  () → void
     - printable bool     show Print button (default true)
     - lang     "es"|"en" drives button copy
*/
export default function DocPreviewModal({ title, html, onClose, printable, lang }) {
  const printIt = () => {
    var w = window.open("", "_blank"); if (!w) return;
    w.document.open(); w.document.write(html || ""); w.document.close();
    setTimeout(() => { try { w.focus(); w.print(); } catch (e) {} }, 600);
  };
  const closeLabel = lang === "es" ? "Cerrar" : "Close";
  const printLabel = lang === "es" ? "Imprimir / PDF" : "Print / PDF";
  return createPortal(
    <div
      style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.55)", zIndex: 10004, display: "flex", justifyContent: "center", alignItems: "flex-start", paddingTop: 20, overflowY: "auto" }}
      onClick={onClose}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{ width: 880, maxWidth: "97vw", background: "#fff", borderRadius: 12, boxShadow: "0 24px 64px rgba(0,0,0,0.3)", overflow: "hidden", marginBottom: 40 }}
      >
        <div style={{ padding: "10px 20px", background: "var(--color-bg-card-solid)", borderBottom: "1px solid var(--color-border)", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <span style={{ fontSize: 14, fontWeight: 700 }}>{title || (lang === "es" ? "Vista previa" : "Preview")}</span>
          <div style={{ display: "flex", gap: 8 }}>
            {printable !== false && (
              <button onClick={printIt} style={{ padding: "6px 16px", borderRadius: 6, border: "none", background: "#1B3A4B", color: "#fff", cursor: "pointer", fontSize: 12, fontWeight: 600 }}>{"🖨 "}{printLabel}</button>
            )}
            <button onClick={onClose} style={{ padding: "6px 14px", borderRadius: 6, border: "1px solid var(--color-border)", background: "transparent", cursor: "pointer", fontSize: 12 }}>{closeLabel}</button>
          </div>
        </div>
        <iframe
          title={title || "preview"}
          srcDoc={html || ""}
          style={{ width: "100%", height: "78vh", border: "none", background: "#fff" }}
        />
      </div>
    </div>,
    document.body,
  );
}
